import React, { FC } from 'react';
import * as Styled from './TicketSignIn.styles';
import * as AuthService from '@modules/auth/service';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/function';
import { useTranslations } from '@shared/modules/translation/hooks';
import { useSendTask } from '@core/http/hooks';
import { AuthenticateParams } from '@modules/auth/model';
import { useAuthContext } from '@modules/auth/context';
import TicketSignInForm from '@modules/ticket/components/sign-in/TicketSignInForm';

interface TicketSignInProps {
  referrer: string;
}

const TicketSignIn: FC<TicketSignInProps> = ({ referrer }) => {
  const translations = useTranslations();
  const { updateProfile } = useAuthContext();

  const [loading, authenticate, error] = useSendTask(AuthService.authenticate);

  const handleSubmit = (params: AuthenticateParams) => {
    pipe(
      () => authenticate(params),
      TE.chainFirstIOK(profile => () => {
        updateProfile(profile);
      }),
    )();
  };

  return (
    <Styled.TicketSignInContainer>
      <Styled.TicketSignInTitle>{translations.tickets.signIn}</Styled.TicketSignInTitle>

      <TicketSignInForm loading={loading} error={error} onSubmit={handleSubmit} referrer={referrer} />
    </Styled.TicketSignInContainer>
  );
};

export default TicketSignIn;
